import { useRef, forwardRef, useImperativeHandle } from "react";

import Header from "./Header";
// import TestComp from './TestComp';
import Content from './Content';

import "../Style/DataTable.css"
import Skeleton from "./Skeleton";

const DataTable = forwardRef((props, ref) => {

    const DataTableRef = useRef(null);


    const childFunction = () => {
        console.log("Child function executed");
    };

    // const handleDataTableRef = () => {
    //     console.log("handleDataTableRef");
    //     console.log(DataTableRef.current);
    // }

    const handleFilterByTrainType = (trainType) => {

        if (trainType === "All Train") {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                DataTableRef.current.children[i].classList.remove("hidden");
            }
            return;
        }

        for (let i = 1; i < DataTableRef.current.children.length; i++) {
            if (DataTableRef.current.children[i].children[0].children[3]?.innerHTML === trainType) {
                DataTableRef.current.children[i].classList.remove("hidden");
            } else {
                DataTableRef.current.children[i].classList.add("hidden");
            }
        }


    }

    const handleFilterByKeyword = (keyword) => {
        console.log("handleFilterByKeyword", keyword);

        for (let i = 1; i < DataTableRef.current.children.length; i++) {

            // let tid = dataTableRow[i].children[0].children[2].innerHTML;
            // let td = dataTableRow[i].children[0].children[3].innerHTML;

            let txt_value = DataTableRef.current.children[i].children[0].children[1]?.innerHTML + " " + DataTableRef.current.children[i].children[0].children[2]?.innerHTML;

            // console.log("txt_value: " + txt_value + "|| input: " + input);

            if (txt_value.toUpperCase().indexOf(keyword.trim().toUpperCase()) > -1) {
                DataTableRef.current.children[i].style.display = "";
            } else {
                DataTableRef.current.children[i].style.display = "none";
            }

        }

    }


    const handleFilterByHideNotInService = () => {

    }

    const handleFilterByShowUpDirection = (isShow, trickStationList) => {
        // check Destination column 
        if (isShow) {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                DataTableRef.current.children[i].classList.remove("up-trick-hidden");
            }
        } else {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                if (trickStationList.includes(DataTableRef.current.children[i].children[0].children[6]?.innerHTML)) {
                    DataTableRef.current.children[i].classList.remove("up-trick-hidden");
                } else {
                    DataTableRef.current.children[i].classList.add("up-trick-hidden");
                }
            }
        }


    }

    const handleFilterByShowDownDirection = (isShow, trickStationList) => {
        // check Destination column 
        if (isShow) {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                DataTableRef.current.children[i].classList.remove("down-trick-hidden");
            }
        } else {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                if (trickStationList.includes(DataTableRef.current.children[i].children[0].children[6]?.innerHTML)) {
                    DataTableRef.current.children[i].classList.remove("down-trick-hidden");
                } else {
                    DataTableRef.current.children[i].classList.add("down-trick-hidden");
                }
            }
        }
    }

    const handleFilterByStation = (station_arr) => {
        if (station_arr.includes("All Stations")) {
            for (let i = 1; i < DataTableRef.current.children.length; i++) {
                DataTableRef.current.children[i].classList.remove("next-station-hidden");
            }
            return;
        }

        for (let i = 1; i < DataTableRef.current.children.length; i++) {
            if (station_arr.includes(DataTableRef.current.children[i].children[0].children[5]?.innerHTML)) {
                DataTableRef.current.children[i].classList.remove("next-station-hidden");
            } else {
                DataTableRef.current.children[i].classList.add("next-station-hidden");
            }
        }

    }


    useImperativeHandle(ref, () => ({
        childFunction, handleFilterByTrainType, handleFilterByKeyword, handleFilterByHideNotInService, handleFilterByShowUpDirection, handleFilterByShowDownDirection, handleFilterByStation
    }));



    return (
        <div className="data-table" ref={DataTableRef}>
            <Header />
            {/* <TestComp /> */}
            {
                //(props.trainloaddata.length === 0)?<Skeleton></Skeleton>:<Content trainloaddata={props.trainloaddata} />
                (Object.keys(props.trainloaddata).length === 0) ? <Skeleton></Skeleton> : <Content  />
            }

        </div>
    );
})

export default DataTable;